import React from "react";
import { Users } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import {
    Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";

export const BidderLimitMeter = ({ count = 0, max = 0, className }) => {
    const pct = max > 0 ? Math.min(100, Math.round((count / max) * 100)) : 0;
    return (
        <div data-testid="bidder-limit-meter" className={className}>
            <div className="mb-1 flex items-center justify-between text-xs">
                <span className="inline-flex items-center gap-1 text-muted-foreground">
                    <Users className="h-3.5 w-3.5" aria-hidden /> Bidders
                </span>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <span data-testid="bidder-limit-meter-label" className="font-display font-semibold tabular-nums">
                                {count}/{max}
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>
                            Auction closes automatically when {max} unique bidders are reached.
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>
            <Progress data-testid="bidder-limit-meter-progress" value={pct} className="h-2" aria-label={`${count} of ${max} bidders`} />
        </div>
    );
};
